import { z } from "zod";
import { userResponseSchema } from "@common/schemas/user.schema";
import { ConnectionProvider } from "@common/types/integrationConnection";
import { utcDatetime } from "@common/helpers/date";
import { jsonValueSchema } from "@common/schemas/json.schema";

export const integrationConnectionResponseSchema = z.object({
    id: z.string(),
    provider: z.nativeEnum(ConnectionProvider),
    providerId: z.string().nullable(),
    label: z.string().nullable(),
    workspaceId: z.string().nullable(),
    entityId: z.number().nullable(),
    createdByUserId: z.number().nullable(),
    createdByUser: userResponseSchema.nullable().default(null),
    createdAt: utcDatetime,
    institutionLogoUrl: z.string().nullable(),
    institutionName: z.string().nullable(),
    metadata: jsonValueSchema,
    error: z.string().nullable(),
    counterpartiesSyncedAt: utcDatetime.nullable(),
    classesSyncedAt: utcDatetime.nullable(),
});
